import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory } from 'react-router-dom';
import PokerFrame from "./PokerFrame";
import { getClubList } from "../../../store/selectors";
import { alterPokerFrame } from '../../../store/actionCreators/club';
import { showNotification } from '../../../store/actionCreators/notification';
import gbParams from '../../../config/parameters';

const PokerFrameList = () => {

    const clubList = useSelector(getClubList);
    const dispatch = useDispatch();
    const history = useHistory();

    const listenForWindowMessages = () => {
        window.addEventListener("message", e => {
            // console.log('EVENT DATA: ', e.data);
            switch (e.data.msg) {
                case 'loginSucceed':
                    console.log('loginSucceed: clubId: ', e.data.clubId);
                    dispatch(alterPokerFrame(e.data.clubId, { status: gbParams.pokerLobbyStates.READY}));
                    break;
                case 'closeTable':
                    dispatch(alterPokerFrame(e.data.clubId, { isVisible: false }));
                    break;
                case 'forceLoggedOut':
                    console.log('forceLoggedOut: clubId: ', e.data.clubId);
                    dispatch(showNotification({ message: "Someone else logged-in using  this account..", appearance: 'error' }));
                    dispatch(alterPokerFrame(e.data.clubId, { status: gbParams.pokerLobbyStates.NONE, wnd: null, closed: true }));
                    setTimeout(() => {
                        dispatch(alterPokerFrame(e.data.clubId, { closed: false }));
                    }, 700)
                    history.push(`/home`);
                    break;
                case 'balanceUpdate':
                    // console.log('balancePARAMs', e.data.params);
                    break;
                default:
                    break;
            }
        }, false);
    };

    useEffect(() => {
        listenForWindowMessages();
    }, []);

    return (
        <div className={`pokerFrames`}>
            {
                clubList.map(club => (
                    <PokerFrame key={club.clubId} club={club}></PokerFrame>
                ))
            }
        </div>
    )
};

export default PokerFrameList;
